import browser from './browser';
import request from '@/Utilities/httpRequest';

export default {
    positionParam: 'sY',
    positionElem: 'sE',
    requestData: {},
    requestTimer: null,
    requestUrl: null,
    requestParams: {},
    requestAttempt: 0,
    suporteWebpST: null,
    supportWebp(){
        if(this.suporteWebpST != null){
            return this.suporteWebpST;
        }
        var elem = document.createElement('canvas');
        this.suporteWebpST = !!(elem.getContext && elem.getContext('2d')) ? elem.toDataURL('image/webp').indexOf('data:image/webp') == 0 : false;
        return this.suporteWebpST;
    },
    isBlockInViewport (el) {
        let rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    },
    getViewPortWidth: function( isMobile = false ){
        if(isMobile) {
            return document.documentElement.clientWidth || window.innerWidth;
        }

        let vp = Math.min(document.documentElement.clientWidth || 2200, window.innerWidth || 2200, 2200);
        return vp < 992 ? 992 : vp;
    },
    getViewPortHeight: function(){
        return window.innerHeight;
    },
    gotoUrl(url,block){
        if(!url || url=='#'){
            return;
        }
        if(!browser.isIE() && block){
            let elem   = document.querySelector(`#${block.elementId}`);
            if(elem){
                this.savePositionData(elem.getBoundingClientRect().top, block.elementId);
            //    let bound  = elem.getBoundingClientRect();
            //    let params = new URLSearchParams(window.location.search);
            //    params.set(this.positionParam, bound.top);
            //    params.set(this.positionElem, block.elementId);
            //    window.history.replaceState({}, document.title, window.location.pathname + "?" + params.toString());
            }
        }
        window.location = url;
    },
    scrollPosition(){
        if(!browser.isIE() && this.isBackForward()){
            let id, pos;
            try {
                pos = parseFloat(sessionStorage.getItem(this.positionParam));
                id  = sessionStorage.getItem(this.positionElem);
            } catch(e) {
                //console.log('Session Storage is disabled');
            }
            // let params = new URLSearchParams(window.location.search);
            // let post   = params.get(this.positionParam);
            // let pos    = parseFloat(post);
            // let id     = params.get(this.positionElem);
            let elem   = id ? document.querySelector(`#${id}`) : null;
            if(pos && elem){
                let s = elem.offsetTop - pos;
                window.scrollTo({
                    top: s, 
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }
        // always clear data
        this.savePositionData(0, null);
    },
    request(key,data,urlParams,callback){
        this.requestData[key] = {callback:callback,data:data};
        this.requestParams    = {...this.requestParams,...urlParams};
        clearTimeout(this.requestTimer);
        this.requestTimer = setTimeout( () => { this.__call(); }, 70);
    },
    __call(){
        clearTimeout(this.requestTimer);
        let resData   = { ...this.requestData };
        let resParams = { ...this.requestParams };
        this.requestData   = {};
        this.requestParams = {};
        let postData = {};
        for (var key in resData) {
            postData[key] = resData[key].data;
        }
        if(Object.keys(postData).length == 0){
            // no data to post, log error and skip request
            if(typeof Bugsnag !== 'undefined'){
                Bugsnag.notify('homeBlocks', 'Empty post data', {}, 'error');
            }            
            return;
        }
        let url = this.requestUrl;
        if(!browser.isIE()){
            let params = new URLSearchParams();
            for (var param in resParams) {
                params.set(param, resParams[param]);
            }
            this.requestAttempt++;
            let paramsTxt = params.toString();
            url = this.requestUrl + (this.requestUrl.includes('/q/') ? '' : '/q') + '/attempt/' + this.requestAttempt + (paramsTxt != '' ? "?" + paramsTxt : '');
        }
        this.__callPost(url,postData,resData, false);
    },
    __callPost(url,postData,resData, retray){
        let keys  = Object.keys(postData);
        let token = btoa(JSON.stringify({
            keys: keys,
            bulk: true,
            version: 'v1',
            retray: retray
        }));
        request.post(url,{ bulk: true, data: postData, retray: retray }, false, {'Content-Type': 'application/json', 'Blocks-Info': token}).then( response => {
            let status = response.status ?? 200;
            if(!retray && (status == 500 || status == 204)){
                return this.__callPost(url,postData,resData, true);
            }
            let data   = response.data;
            for (var key in resData) {
                if(resData[key].hasOwnProperty('callback') && resData[key].callback){
                    if(data.hasOwnProperty(key)){
                        resData[key].callback({data: data[key]});
                    }else{
                        resData[key].callback({data: {}});
                    }
                }
            }
        });
    },
    removeAnchor(){
        // if(!browser.isIE() && !browser.isSafari()){
        //     let params = new URLSearchParams(window.location.search);
        //     let hash   = window?.location?.hash ?? '';
        //     params.delete(this.positionParam);
        //     params.delete(this.positionElem);
        //     let p = params.toString();
        //     window.history.replaceState({}, document.title, window.location.pathname + (p != '' ? '?' : '') + p + hash) ;
        // }
    },
    removeClass(label){
        let el = document.createElement( 'html' );
        el.innerHTML = label;
        let span = el.getElementsByTagName('span');
        for (var i=0; i < span.length; i++) {
            span[i].style.color = null;
            span[i].className = 'block-label-span';
        }
        let icons = el.getElementsByTagName('i');
        for (var i=0; i < icons.length; i++) {
            icons[i].style.color = null;
            let classes = Array.from(icons[i].classList.values());
            for(let v of classes) {
                if(!v.includes('icon-') && !v.includes('prz-')){
                    icons[i].classList.remove(v);
                }
            }
        }
        return el.innerHTML;
    },
    setPropertyVW(){
        let winWidth     = this.getViewPortWidth();
        let vh           = winWidth * 0.01;
        
        //Fix for firefox, snaps don't like rounding with 0.5
        if(browser.isFirefox()){
            let pxInt = Math.trunc(vh);
            let pxDcm = vh - pxInt;
            if(Math.trunc(pxDcm * 100) == 50){
                vh = vh + 0.01;
            }
        }

        //To calc the block size easy
        document.documentElement.style.setProperty('--vw', `${vh}px`);
    },
    savePositionData(top, elementId){
        try {
            sessionStorage.setItem(this.positionParam, top);
            sessionStorage.setItem(this.positionElem, elementId);
        } catch(e) {
            //console.log('Session Storage is disabled');
        }
    },
    isBackForward(){
        // use performance timming API to check if page load happened because of back/forward
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
        // get navigation entries that happened until now
        const entries = performance ? performance.getEntriesByType("navigation") : [];
        // check if there is one with type "back_forward"
        return entries.find(entry => entry.type === "back_forward") ? true : false;
    }
}
